import { Component } from '@angular/core';
import { CommonService } from './common/common.service';
declare var $: any;
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { DataService } from './shared/services/data.service';
import { SnackbarService } from './shared/services/snackbar.service';
import { LoginService } from './modules/auth/services/login.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'config-portal';
  msg: string = '';
  defaultModule: string = '';
  userActivityData: any;
  setInterval: any;
  dataRefreshInterval: number = 0;
  appTimeout: number = null;
  appTimeoutCutOff: number = null;
  timedOut = false;
  countdown: number = null;
  lastPing: Date = null;
  subscription: Subscription = new Subscription();
  moduleName: string;
  levelName: string;
  pageName: string;
  constructor(private commonService: CommonService, private idle: Idle, private keepAlive: Keepalive, private loginService: LoginService, private router: Router, private dataService: DataService, private snackbarService: SnackbarService) {
  }
  ngOnInit() {
    this.commonService.readConfigurationsData().subscribe(data => {
      sessionStorage.setItem('url', data['url']);
      sessionStorage.setItem('apiUrl', data['apiUrl']);
      sessionStorage.setItem('wsUrl', data['websocketUrl']);
      this.defaultModule = data['defaultModule'];
      // let url = window.location.href;
      // sessionStorage.removeItem('redirectUrl');
    });
  }
  reset() {
    this.idle.watch();
    this.timedOut = false;
  }

  logout() {
    this.loginService.logout().subscribe(
      (data: any) => {
        if (data['response_code'] === 1) {
          this.loginService.clearData();
          this.router.navigateByUrl('auth/logout');
        }
      },
      error => {
        this.msg = 'Error occured. Please try again.';
        this.snackbarService.show(this.msg, true, false, false, false);
      },
      () => {
      }
    )
  }
  ngOnDestroy() {
    clearInterval(this.dataRefreshInterval);
  }

}
